{
  "$schema": "https://raw.githubusercontent.com/martinring/tmlanguage/master/tmlanguage.json",
  "name": "STM",
  "scopeName": "source.stm",
  "patterns": [
    { "include": "#comments" },
    { "include": "#strings" },
    { "include": "#chars" },
    { "include": "#numbers" },
    { "include": "#declarations" },
    { "include": "#keywords" },
    { "include": "#member-access" },
    { "include": "#function-call" },
    { "include": "#types" },
    { "include": "#identifiers" },
    { "include": "#operators" }
  ],
  "repository": {
    "comments": {
      "patterns": [
        { "name": "comment.line.double-slash.stm", "match": "//.*$" },
        { "name": "comment.line.number-sign.stm", "match": "#.*$" }
      ]
    },
    "strings": {
      "name": "string.quoted.double.stm",
      "begin": "\"",
      "beginCaptures": {
        "0": { "name": "punctuation.definition.string.begin.stm" }
      },
      "end": "\"",
      "endCaptures": {
        "0": { "name": "punctuation.definition.string.end.stm" }
      },
      "patterns": [
        { "name": "constant.character.escape.stm", "match": "\\\\." }
      ]
    },
    "chars": {
      "name": "string.quoted.single.stm",
      "match": "'(\\\\.|[^'\\\\])'",
      "captures": {
        "1": { "name": "constant.character.escape.stm" }
      }
    },
    "numbers": {
      "patterns": [
        { "name": "constant.numeric.float.stm", "match": "\\b[0-9]+\\.[0-9]+\\b" },
        { "name": "constant.numeric.integer.stm", "match": "\\b[0-9]+\\b" }
      ]
    },
    "keywords": {
      "patterns": [
        {
          "name": "keyword.control.stm",
          "match": "\\b(if|else|while|for|in|match|return|go|txn|retry|raise|try|catch|assert)\\b"
        },
        {
          "comment": "`builtin` is a contextual modifier — only a keyword when it heads a declaration: `builtin fn` or `builtin struct` (a natively-backed type like `Dict`).",
          "name": "keyword.declaration.stm",
          "match": "\\bbuiltin\\b(?=\\s+(?:fn|struct)\\b)"
        },
        {
          "comment": "A trailing effect annotation: `!` followed by effect names from the closed vocabulary (`io`, `retry`, `raises`, `spawn`), after a signature — `fn f(x) T ! io raises`.",
          "name": "keyword.other.effect.stm",
          "match": "!\\s*(?:io|retry|raises|spawn)(?:\\s+(?:io|retry|raises|spawn))*"
        },
        {
          "name": "keyword.declaration.stm",
          "match": "\\b(struct|enum|trait|impl|fn|let)\\b"
        },
        {
          "name": "constant.language.boolean.stm",
          "match": "\\b(true|false)\\b"
        },
        {
          "name": "variable.language.self.stm",
          "match": "\\bself\\b"
        },
        {
          "name": "support.type.primitive.stm",
          "match": "\\b(int|float|bool|string|str|char|void|Set|Dict|List|Future)\\b"
        }
      ]
    },
    "declarations": {
      "patterns": [
        {
          "match": "\\b(fn)\\s+([A-Za-z_][A-Za-z0-9_]*)",
          "captures": {
            "1": { "name": "keyword.declaration.stm" },
            "2": { "name": "entity.name.function.stm" }
          }
        },
        {
          "match": "\\b(struct|enum|trait|impl)\\s+([A-Z][A-Za-z0-9_]*)",
          "captures": {
            "1": { "name": "keyword.declaration.stm" },
            "2": { "name": "entity.name.type.stm" }
          }
        }
      ]
    },
    "member-access": {
      "patterns": [
        {
          "comment": "Method call on a receiver: `.name(` — highlighted as a function.",
          "match": "(\\.)\\s*([A-Za-z_][A-Za-z0-9_]*)\\s*(?=\\()",
          "captures": {
            "1": { "name": "punctuation.accessor.stm" },
            "2": { "name": "entity.name.function.member.stm" }
          }
        },
        {
          "comment": "Field / property access: `.name`.",
          "match": "(\\.)\\s*([A-Za-z_][A-Za-z0-9_]*)",
          "captures": {
            "1": { "name": "punctuation.accessor.stm" },
            "2": { "name": "variable.other.property.stm" }
          }
        }
      ]
    },
    "function-call": {
      "comment": "A lowercase identifier immediately followed by `(` is a call; uppercase names fall through to #types so constructors stay type-colored.",
      "match": "\\b([a-z_][A-Za-z0-9_]*)\\s*(?=\\()",
      "captures": {
        "1": { "name": "entity.name.function.stm" }
      }
    },
    "types": {
      "patterns": [
        { "name": "entity.name.type.stm", "match": "\\b[A-Z][A-Za-z0-9_]*\\b" }
      ]
    },
    "identifiers": {
      "comment": "Any remaining lowercase identifier is a local variable / binding.",
      "patterns": [
        { "name": "variable.other.stm", "match": "\\b[a-z_][A-Za-z0-9_]*\\b" }
      ]
    },
    "operators": {
      "name": "keyword.operator.stm",
      "match": "(\\+=|-=|\\*=|/=|==|!=|<=|>=|&&|\\|\\||=>|->|\\.\\.|[=+\\-*/%<>!])"
    }
  }
}
